<template>
	<div class="tips-container" @click="next">
		<transition name="tip" mode="out-in">
			<div class="tip" :key="current">
				<div class="illustration">
					<img v-if="tips[current].image" :src="tips[current].image" alt="" />
				</div>
				<div class="divider"></div>
				<p class="text">{{ tips[current].text }}</p>
			</div>
		</transition>
	</div>
</template>

<script>
	const TIP_DURATION = 8000;

	export default {
		name: 'TipsComponent',
		data() {
			return {
				current: 0,
				interval: null,
				// image is optional, the illustrations are not designed yet
				tips: [
					{ id: 'keyboard', text: 'You can use your physical Bluetooth keyboards to type faster.' },
					{ id: 'hide-hand', text: 'To temporarily hide hand visuals while using hand tracking you can press the menu button on your left hand.' },
					{ id: 'review', text: 'If you like the spatial app you can leave a review on the Meta Quest store.' },
				],
			}
		},
		mounted() {
			this.start();
		},
		unmounted() {
			clearInterval(this.interval);
		},
		methods: {
			start() {
				clearInterval(this.interval);
				this.interval = setInterval(this.advance, TIP_DURATION);
			},
			advance() {
				this.current = (this.current + 1) % this.tips.length;
			},
			next() {
				this.advance();
				// Give the tip the user moved to the full duration
				this.start();
			},
		},
	}
</script>

<style lang="scss">
	html, body {margin: 0; height: 100%; overflow: hidden}
</style>

<style scoped lang="scss">
	.tips-container {
		position: relative;
		width: 400px;
		height: 400px;
		background-color: #0C0E11;
		overflow: hidden;
		user-select: none;

		&:hover {
			cursor: pointer;
		}

		.tip {
			position: absolute;
			inset: 0;

			.illustration {
				position: absolute;
				left: 40px;
				right: 40px;
				top: 40px;
				bottom: 199px;
				display: flex;
				align-items: center;
				justify-content: center;

				img {
					max-width: 100%;
					max-height: 100%;
				}
			}

			.divider {
				position: absolute;
				left: 40px;
				top: 217px;
				width: 320px;
				height: 1px;
				background-color: #FFFFFF29;
			}

			.text {
				position: absolute;
				left: 40px;
				top: 241px;
				width: 320px;
				margin: 0;
				color: #FFFFFF;
				font-family: Inter, sans-serif;
				font-size: 20px;
				font-weight: 500;
				line-height: 1.5;
			}
		}
	}

	.tip-enter-active,
	.tip-leave-active {
		transition: opacity 400ms ease-out, transform 400ms ease-out;
	}

	.tip-enter-from {
		opacity: 0;
		transform: translateX(24px);
	}

	.tip-leave-to {
		opacity: 0;
		transform: translateX(-24px);
	}
</style>
